import { render } from "./DashboardStats.vue?vue&type=template&id=2670ecea&scoped=true"
import script from "./DashboardStats.vue?vue&type=script&lang=js"
export * from "./DashboardStats.vue?vue&type=script&lang=js"

import "./DashboardStats.vue?vue&type=style&index=0&id=2670ecea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2670ecea"]])

export default __exports__